import * as React from "react";
import { Layout } from "antd";
import { ActualsTabKey, useActualsStore } from "@/state/actuals/actualsStore";
import { useDataSourceInfoStore } from "@/state/actuals/dataSourceInfoStore";

const { Header } = Layout;

const navigationItems: { key: ActualsTabKey; label: string }[] = [
  { key: "data-source-info", label: "Data Source Info" },
  { key: "common-equity", label: "Common Equity" },
  { key: "preferred-equity", label: "Preferred Equity" },
  { key: "convertibles", label: "Convertibles" },
  { key: "cash", label: "Cash" },
  { key: "debt", label: "Debt" },
  { key: "debt-equivalents", label: "Debt Equivalents" },
];

const ActualsHeader: React.FC = () => {
  const activeTab = useActualsStore((s) => s.activeTab);
  const setActiveTab = useActualsStore((s) => s.setActiveTab);

  const handleMenuClick = (key: ActualsTabKey) => {
    setActiveTab(key);
    const { reset } = useDataSourceInfoStore.getState();  
    reset();
    // TODO: wire navigation/actions for each tab when the Actuals workflow is implemented
  };

  return (
    <Header className=" !h-8 w-full flex justify-between items-center !bg-white !px-0">
      {/* Main Navigation Menu */}
      <div className="flex w-full justify-between items-center gap-10">
        {navigationItems.map((item) => (
          <div
            key={item.key}
            className={`flex justify-start items-center gap-2 cursor-pointer transition-colors navigation-menu-item ${
              activeTab === item.key
                ? "company-color-text font-bold text-[var(--color-as-orange-primary)] text-[13px] "
                : "text-gray-700 text-[13px]"
            }`}
            onClick={() => handleMenuClick(item.key)}
          >
           {item.label}
          </div>
        ))}
      </div>
    </Header>
  );
};

export default ActualsHeader;


